export default "__VITE_ASSET__DlpDIzFq__ 640w, __VITE_ASSET__uIXllQ5x__ 1024w";